var o = {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  t = {
    height: "auto"
  },
  i = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: "scroll",
    WebkitOverflowScrolling: "touch"
  },
  e = {
    position: "relative",
    top: void 0,
    left: void 0,
    right: void 0,
    bottom: void 0
  },
  l = {
    overflow: "hidden",
    marginRight: 0,
    marginBottom: 0
  },
  r = {
    position: "absolute",
    height: 6
  },
  h = {
    position: "relative",
    width: 6
  },
  s = {
    position: "relative",
    display: "block",
    height: "100%"
  },
  n = {
    position: "relative",
    display: "block",
    width: "100%"
  },
  a = {
    userSelect: "none"
  },
  p = {
    userSelect: ""
  };
export { t as containerStyleAutoHeight, o as containerStyleDefault, a as disableSelectStyle, p as disableSelectStyleReset, s as thumbHorizontalStyleDefault, n as thumbVerticalStyleDefault, r as trackHorizontalStyleDefault, h as trackVerticalStyleDefault, e as viewStyleAutoHeight, i as viewStyleDefault, l as viewStyleUniversalInitial };